<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="customStatusModal" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">Set Custom Status</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form v-if="!loading" @submit.prevent="updateStatus()">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <button v-if="editing" class="btn btn-danger btn-sm pull-right" @click.prevent="deleteStatus()">Delete Status</button>
                    <label>Custom Status</label>
                    <input type="text" class="form-control" v-model.trim="task.customStatus">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button class="btn btn-primary btn-sm" type="submit">Update Status</button>
                </div>
              </div>
            </form>
            <div v-else class="loader"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init"
export default {
  name: "customStatusModal",
  data() {
    return {
      loading: false,
      task: {},
      editing: false
    }
  },
  methods: {
    load(task) {
      this.task = task
      this.editing = !!(this.task.customStatus)
      $('#customStatusModal').modal('show');
    },
    async updateStatus() {
      this.loading = true
      await db.collection('CFEnterpriseRequests').doc(this.task.docId).update({
        customStatus: this.task.customStatus,
        modified: new Date().toISOString()
      })
      await $('#customStatusModal').modal('hide');
      this.loading = false
    },
    deleteStatus() {
      this.loading = true
      this.task.customStatus = null
      this.updateStatus()
    }
  }
}
</script>

<style scoped>

</style>
